import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import financialAnalysisService from '../../../../core/services/Fundamental/FinancialAnalysisService';
import { withComponentId } from '../../../common/ComponentIdContext';
import ExportBlob from '../../../common/export-blob';
import Tab from '../../../common/tab-timer';
import { getCurrentDate } from '../../../helpers/Common';
import { handleExport } from '../../../helpers/HandleExport';
import {
  bankingMapping,
  mapFrequency,
  mapping,
  subIndicators,
} from '../constants';
import { changeTimeFilter, REDUCER_NAME } from '../reducer';

class Filter extends PureComponent {
  getMappingObject = () => {
    const { searchParams } = this.props;

    return searchParams.isBanking ? bankingMapping : mapping;
  };

  getRatios = () => {
    const { hideIndicators } = this.props;
    const ratios = [];
    const mapping = this.getMappingObject();

    const arr = Object.entries(mapping);
    const newArr = arr.filter(([key, value]) => value != '');
    const mappingObj = Object.fromEntries(newArr);

    Object.keys(mappingObj).forEach(key => {
      const isSubIndicator = subIndicators.includes(key);
      if (!hideIndicators[key] && !isSubIndicator) {
        ratios.push(mappingObj[key]);
      }
    });

    return ratios;
  };

  handleExport = async () => {
    const { searchParams, isFilterIndustry, compares, timeFilter } = this.props;
    const params = {
      OrganCode: searchParams.code,
      CompareToIndustry: isFilterIndustry,
      CompareToCompanies: compares.map(item => item.organCode),
      Frequency: mapFrequency[timeFilter],
      Ratios: this.getRatios(),
    };
    const response = await financialAnalysisService.downloadFinancialRatio(
      params,
    );
    const name = I18n.t('common.export.financialAnalysis.financialRatio', {
      ticker: searchParams.displayCode,
      date: getCurrentDate(),
    });
    handleExport(response, name);
  };

  changeTab = timeFilter => {
    const { changeTimeFilter, componentId } = this.props;
    changeTimeFilter({ componentId, timeFilter });
  };

  render() {
    const { timeFilter } = this.props;

    return (
      <div className="filter d-flex">
        <div className="mr-5 ml-20">
          <Tab
            disableTabNormal={true}
            currentTab={timeFilter}
            listTab="financialAnalysis.financialRatio.timeTab"
            changeTab={this.changeTab}
          />
        </div>
        <ExportBlob handleExport={this.handleExport} />
      </div>
    );
  }
}

Filter.propTypes = {};

const mapStateToProps = (state, { componentId }) => ({
  timeFilter: state[REDUCER_NAME][componentId].timeFilter,
  searchParams: state[REDUCER_NAME][componentId].searchParams,
  isFilterIndustry: state[REDUCER_NAME][componentId].isFilterIndustry,
  compares: state[REDUCER_NAME][componentId].compares,
  hideIndicators: state[REDUCER_NAME][componentId].hideIndicators,
});

const mapDispatchToProps = {
  changeTimeFilter,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Filter);
